import React, { CSSProperties, FC, ReactNode } from 'react';
import clsx from 'clsx';
import { Icon } from '@namespace/icons2';
import { AText } from '../AText';
import { Box } from '../Box';

import styles from './index.module.css';

interface InfoMessageProps {
  children?: ReactNode;
  icon?: string;
  color?: string;
  className?: string;
  breed?: string;
  align?: string;
  size?: '2xs' | 'xs' | 's' | 'm' | 'l' | 'xl' | '2xl' | '3xl' | '4xl';
  dataRole?: string;
  iconWrapClassName?: string;
  style?: CSSProperties;
}

export const InfoMessage: FC<InfoMessageProps> = ({
  children,
  icon,
  className = '',
  breed = 'R',
  align = 'left',
  dataRole,
  iconWrapClassName = '',
  color = '',
  ...rest
}) => {
  return (
    <Box className={clsx(styles.infoMessage, className)}>
      {icon && (
        <Icon
          name={icon === 'info' ? 'icons/general/alert/info' : icon}
          size="s"
          color={color || 'po_txt_color_3'}
          className={clsx(
            styles.iconWrap,
            styles.infoMessageColor,
            iconWrapClassName
          )}
          data-role={dataRole && `${dataRole}-icon`}
        />
      )}
      {children && (
        <AText
          data-role={dataRole && `${dataRole}-text`}
          breed={breed as 'R' | 'RU' | 'B' | 'BU'}
          className={styles.infoMessageColor}
          color={color || 'po_txt_color_3'}
          size="s"
          align={align as 'left' | 'center' | 'right'}
          {...rest}
        >
          {children}
        </AText>
      )}
    </Box>
  );
};
